interface NhostSignOut {
  getUserSession(): { refreshToken: string } | null
  clearSession(): void
  auth: { signOut(body: { refreshToken?: string }): Promise<unknown> }
}

// Signs out and revokes the refresh token on the server (#155). auth refuses a
// sign-out without refresh token (400 "The request payload is incorrect"),
// which left the token valid until it expired.
export async function signOutSession(nhost: NhostSignOut) {
  const refreshToken = nhost.getUserSession()?.refreshToken
  if (!refreshToken) return nhost.clearSession()
  await nhost.auth.signOut({ refreshToken })
}
